// components/CardExpandible.jsx
import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Box,
  Typography,
  useTheme,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  AppBar,
  Toolbar,
  Slide,
  Divider
} from '@mui/material';
import {
  OpenInFull as ExpandIcon,
  CloseFullscreen as CompressIcon,
  Close as CloseIcon
} from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CardExpandible = ({ 
  title, 
  icon: Icon, 
  children, 
  subtitle,
  actionButtons
}) => {
  const theme = useTheme();
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleExpand = () => {
    setIsFullScreen(true);
  };

  const handleCloseFullScreen = () => {
    setIsFullScreen(false);
  };

  return (
    <>
      {/* Card normal - Mitad de pantalla */}
      <Card 
        elevation={1} 
        sx={{ 
          width: '100%',
          height: '100%',
          minHeight: '400px',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 1,
          border: '1px solid #e8e8e8',
          transition: 'all 0.2s ease',
          '&:hover': {
            boxShadow: theme.shadows[3],
            borderColor: '#d0d0d0',
          }
        }}
      >
        <CardHeader
          avatar={
            <Box 
              sx={{ 
                color: '#424242',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {Icon && <Icon sx={{ fontSize: 24 }} />}
            </Box>
          }
          title={
            <Typography variant="h6" sx={{ fontWeight: 500, color: '#1a1a1a', fontSize: '1.05rem' }}>
              {title}
            </Typography>
          }
          subheader={
            subtitle && (
              <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.75rem' }}>
                {subtitle}
              </Typography>
            )
          }
          action={
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              {actionButtons}
              <IconButton 
                onClick={handleExpand}
                size="small"
                sx={{ 
                  color: '#757575',
                  '&:hover': {
                    backgroundColor: 'rgba(0,0,0,0.04)',
                  }
                }}
              >
                <ExpandIcon fontSize="small" />
              </IconButton>
            </Box>
          }
          sx={{
            pb: 0,
            '& .MuiCardHeader-content': {
              overflow: 'hidden',
            }
          }}
        />
        <Divider sx={{ mx: 2 }} />
        <CardContent sx={{ 
          flex: 1, 
          overflow: 'auto', 
          p: 2.5,
          '&:last-child': {
            pb: 2.5
          }
        }}>
          {children}
        </CardContent>
      </Card>

      {/* Full Screen Dialog - Profesional */}
      <Dialog
        fullScreen
        open={isFullScreen}
        onClose={handleCloseFullScreen}
        TransitionComponent={Transition}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: '#f7f8fa'
          }
        }}
      >
        <AppBar 
          position="sticky" 
          sx={{ 
            backgroundColor: '#ffffff',
            color: '#1a1a1a',
            boxShadow: 'none',
            borderBottom: '1px solid #e8e8e8'
          }}
        >
          <Toolbar sx={{ minHeight: 56 }}>
            <Box 
              sx={{ 
                color: '#424242',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mr: 1.5
              }}
            >
              {Icon && <Icon sx={{ fontSize: 24 }} />}
            </Box>
            <Typography variant="h6" sx={{ flex: 1, fontWeight: 500, fontSize: '1.05rem' }}>
              {title}
            </Typography>
            <IconButton 
              onClick={handleCloseFullScreen}
              sx={{ 
                color: '#757575',
                mr: 0.5,
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.04)',
                }
              }}
            >
              <CompressIcon />
            </IconButton>
            {/* <IconButton 
              onClick={handleCloseFullScreen}
              sx={{ 
                color: '#757575',
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.04)',
                }
              }}
            >
              <CloseIcon />
            </IconButton> */}
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ p: 3, backgroundColor: '#f7f8fa' }}>
          {children}
        </DialogContent>
        {/* <DialogActions sx={{ 
          p: 2, 
          borderTop: '1px solid #e8e8e8',
          backgroundColor: '#ffffff'
        }}>
          <Button 
            onClick={handleCloseFullScreen}
            variant="outlined"
            size="small"
            sx={{
              color: '#424242',
              borderColor: '#d0d0d0',
              textTransform: 'none',
              '&:hover': {
                borderColor: '#b0b0b0',
                backgroundColor: 'rgba(0,0,0,0.02)',
              }
            }}
            startIcon={<CompressIcon />}
          >
            Cerrar vista completa
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
};

export default CardExpandible;